export const MI_SERVICE_TYPES = [
  "essSmip",
  "essPfr",
  "ebr",
  "pvSmip",
  "pvStpr",
  "pvPft",
  "essStpr",
  "customReportsMi",
  "webinars",
  "ebrMaterials",
];

export const isMiServiceType = (serviceType) =>
  typeof serviceType === "string" && MI_SERVICE_TYPES.includes(serviceType);
